/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from "react";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Paper,
  Typography,
  Divider,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";

import FDropDown from "../../../fluid/Elements/Inputs/FDropDown";
import Actions from "../../../fluid/Actions/ActionFactory";
import AddWebService from "../../WebService/AddWebService";
import { withRouter } from "react-router-dom";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";
import { TrainRounded } from "@material-ui/icons";

const styles = (theme) => ({
  text_field: {
    width: "100%",
  },
});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const INITIAL_HELPER_TEXTS = {
  wf_name_helper_text: "Choose a Unique name for the Workflow",
  wf_title_helper_text: "Provide a title for the Workflow",
  wf_description_helper_text: "Write a description for the Workflow",
  ws_helper_text: "Select Edge Service",
  wf_key_helper_text: "Choose a key for the Workflow",
  ic_name_helper_text:
    "Choose the IC under the context of which the Workflow will run",
  type_helper_text: "Choose a type for the Workflow",
};

class CreateWorkflow extends Component {
  state = {
    wf_name: "",
    wf_name_error: false,
    wf_name_helper_text: INITIAL_HELPER_TEXTS.wf_name_helper_text,
    wf_key: "",
    wf_key_error: false,
    wf_key_helper_text: INITIAL_HELPER_TEXTS.wf_key_helper_text,
    wf_keys: [{ label: "Mail Classify Ticket", value: "Mail Classify Ticket" }],
    //iu_type : "",
    //iu_type_error : false,
    //iu_type_helper_text : "Choose the Information Unit Type",
    wf_title: "",
    wf_title_error: "",
    wf_title_helper_text: INITIAL_HELPER_TEXTS.wf_title_helper_text,
    wf_description: "",
    wf_description_error: "",
    wf_description_helper_text: INITIAL_HELPER_TEXTS.wf_description_helper_text,
    ws: "",
    ws_error: false,
    ws_helper_text: INITIAL_HELPER_TEXTS.ws_helper_text,
    ic_name: "",
    ic_name_error: false,
    ic_name_helper_text: INITIAL_HELPER_TEXTS.ic_name_helper_text,
    adaptors: [],
    adaptor_error: false,
    add_web_service: false,
    type: "",
    type_error: false,
    type_helper_text: INITIAL_HELPER_TEXTS.type_helper_text,
    sub_type: "",
    error: false,
    error_message: null,
    errorOpen: false,
    errorInfo: {},
  };

  componentWillMount() {
    if (this.props.wf_name !== null) {
      Actions("http_request", {
        url: "/sainapse/workflow/" + this.props.wf_name,
        method: "get",
        data: {},
      }).then((res) => {
        let result = res.data.result;
        this.setState({
          ...this.state,
          wf_name: result.name,
          wf_key: result.key,
        });
      });
    }
  }

  componentDidMount() {
    // const headingHeight = this.heading.current.clientHeight
    // const footerHeight = this.footer.current.clientHeight
    const contentHeight = this.props.maxHeight;
    this.setState({ ...this.state, content_height: contentHeight });
  }

  heading = React.createRef();
  footer = React.createRef();

  handleChange = (value, state_key) => {
    this.setState(
      {
        ...this.state,
        [state_key]: value,
      },
      () => {
        this.validateField(state_key);
        console.log("Create WF State: ", this.state);
      }
    );
  };

  renderWFKeyDropDown = () => {
    if (this.state.ws !== "" && this.state.ws !== null) {
      return (
        <div style={{ width: "100%" }}>
          <FDropDown
            instance={{
              label: "Workflow Key",
              helper_text: this.state.wf_key_helper_text,
              props: {
                width: "100",
                variant: "standard",
              },
              value_store: ["wf_key"],
              eval_value: "",
              error: this.state.wf_key_error,
              async_values: true,
              api_config: {
                args: {
                  url: "/sainapse/web_service/" + this.state.ws + "/workflow",
                  method: "get",
                  data: {},
                },
                response_key: "result",
                val_key: "key",
                label_key: "",
              },
              values: [],
              render_condition: "",
              mandatory: true,
              onBlur: () => this.validateField("wf_key"),
            }}
            handleChange={(state_key, value) => {
              this.handleChange(value, state_key[0]);
              //this.getAdaptors(value)
            }}
          />
        </div>
      );
    }
  };

  closeWebServiceDialog = () => {
    this.setState({ ...this.state, add_web_service: false });
  };

  openWebServiceDialog = () => {
    this.setState({ ...this.state, add_web_service: true });
  };

  closeError = () => {
    this.setState({ ...this.state, error: false, error_message: null });
  };

  createWorkflow = () => {
    Actions("http_request", {
      url: "/sainapse/workflow",
      method: "post",
      data: {
        name: this.state.wf_name,
        key: this.state.wf_key,
        title: this.state.wf_title,
        description: this.state.wf_description,
        web_service: {
          name: this.state.ws,
        },
        setup_complete: false,
        schedule: [],
        ic_name: this.state.ic_name,
        type: this.state.type,
      },
    })
      .then((res) => {
        console.log("wf res", res);
        this.setState({ ...this.state, wf_name: res.data.result.name }, () =>
          this.props.handleNext({
            wf_name: this.state.wf_name,
            ic_name: this.state.ic_name,
            wf_type: this.state.type,
          })
        );
      })
      .catch((err) => {
        let response = err.response.data;
        if (Array.isArray(response.errors)) {
          response.errors.map((error) => {
            this.setState({
              ...this.state,
              ["wf_" + error.attribute + "_error"]: true,
              ["wf_" + error.attribute + "_helper_text"]: error.message,
              error: false,
              error_message: null,
            });
          });
        } else {
          this.setState({
            ...this.state,
            error: true,
            error_message: response,
          });
        }
      });
  };

  validateField = (field) => {
    console.log("validate workflow", this.state[field]);
    if (this.state[field] !== "") {
      let error = false;
      this.setState({ [field + "_error"]: error });
      this.setState({
        [field + "_helper_text"]: INITIAL_HELPER_TEXTS[field + "_helper_text"],
      });
      return true;
    } else {
      let error = true;
      this.setState({ [field + "_error"]: error });
      this.setState({
        [field + "_helper_text"]: "Field value cannot be empty",
      });
      return false;
    }
  };

  validateAllFields = () => {
    let fields = [
      "wf_name",
      "wf_title",
      "wf_description",
      "ws",
      "wf_key",
      "ic_name",
      "type",
    ];
    let field_validation = fields.map((field) => {
      return this.validateField(field);
    });

    if (field_validation.filter((field) => field === false).length === 0) {
      return true;
    } else {
      return false;
    }
  };

  validateAndCreateWorkFlow = () => {
    console.log("Wf State before");
    console.log("Validating IU Fields :", this.validateAllFields());
    if (this.validateAllFields() === true) {
      this.createWorkflow();
    }
  };

  renderIUSelection = () => {};

  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          width: "100%",
          height: this.props.maxHeight,
          backgroundColor: "#F0F0F0",
          display: "flex",
          flexDirection: "row",
          justifyItems: "center",
          alignItems: "center",
        }}
      >
        {/* <div ref = {this.heading} 
                        style = {{
                            display : 'flex', 
                            flexDirection : 'row', 
                            alignItems : 'flex-end',
                            backgroundColor : '#F0F0F0',
                            borderBottom : '1px solid rgba(0,0,0,0.12)',
                            padding : '8px'
                        }}>
                        <Typography style = {{flexGrow : 1}} variant='h6'>Create Information Unit</Typography>
                    </div> */}
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: this.state.content_height,
            maxHeight: this.state.content_height,
            overflow: "scroll",
            padding: "8px",
          }}
        >
          <Paper
            elevation={4}
            style={{
              padding: "10px",
              width: "60%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ width: "100%" }}>
              <Typography variant="h6">Create Workflow</Typography>
              <Divider style={{ marginTop: "5px", marginBottom: "10px" }} />
            </div>
            <ThemeProvider theme={blue_theme}>
              <TextField
                key="wf_name"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Workflow Name"
                defaultValue=""
                multiline={false}
                label="Workflow Name"
                value={this.state.wf_name}
                error={this.state.wf_name_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.wf_name_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "wf_name")
                }
                onBlur={() => this.validateField("wf_name")}
              />
              <TextField
                key="wf_title"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Workflow Title"
                defaultValue=""
                multiline={false}
                label="Workflow Title"
                value={this.state.wf_title}
                error={this.state.wf_title_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.wf_title_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "wf_title")
                }
                onBlur={() => this.validateField("wf_title")}
              />
              <TextField
                key="wf_description"
                className={classes.text_field}
                disabled={this.state.submission}
                name="Workflow Description"
                defaultValue=""
                multiline={true}
                rowsMax="4"
                label="Workflow Description"
                value={this.state.wf_description}
                error={this.state.wf_description_error}
                type="string"
                required={true}
                variant="standard"
                size="small"
                helperText={this.state.wf_description_helper_text}
                onChange={(event) =>
                  this.handleChange(event.target.value, "wf_description")
                }
                onBlur={() => this.validateField("wf_description")}
              />
              <div style={{ width: "100%" }}>
                <FDropDown
                  instance={{
                    label: "Edge Service",
                    helper_text: this.state.ws_helper_text,
                    props: {
                      width: "100",
                      variant: "standard",
                    },
                    value_store: ["ws"],
                    eval_value: "",
                    error: this.state.ws_error,
                    default_value: "",
                    async_values: true,
                    api_config: {
                      args: {
                        url: "/sainapse/web_service",
                        method: "get",
                        data: {},
                      },
                      response_key: "result",
                      val_key: "name",
                      label_key: "",
                    },
                    values: [],
                    render_condition: "",
                    mandatory: true,
                    onBlur: () => this.validateField("ws"),
                  }}
                  handleChange={(state_key, value) => {
                    this.handleChange(value, state_key[0]);
                    //this.getAdaptors(value)
                  }}
                />
              </div>
              <FormControl
                style={{ width: "100%" }}
                variant="standard"
                margin="dense"
                error={this.state.type_error}
              >
                <InputLabel>Workflow Type</InputLabel>
                <Select
                  value={this.state.type}
                  onChange={(event) => {
                    this.handleChange(event.target.value, "type");
                    this.validateField("type");
                  }}
                >
                  <MenuItem value="Action">Action</MenuItem>
                  <MenuItem value="Process">Process</MenuItem>
                </Select>
                <FormHelperText>{this.state.type_helper_text}</FormHelperText>
              </FormControl>
              {this.renderWFKeyDropDown()}
              <div style={{ width: "100%" }}>
                <FDropDown
                  instance={{
                    label: "Information Channel",
                    helper_text: this.state.ic_name_helper_text,
                    props: {
                      width: "100",
                      variant: "standard",
                    },
                    value_store: ["ic_name"],
                    eval_value: "",
                    error: this.state.ic_name_error,
                    default_value: "",
                    async_values: true,
                    api_config: {
                      args: {
                        url: "/sainapse/information_channel",
                        method: "get",
                        data: {},
                      },
                      response_key: "result",
                      val_key: "name",
                      label_key: "",
                    },
                    values: [],
                    render_condition: "",
                    mandatory: true,
                    onBlur: () => this.validateField("ic_name"),
                  }}
                  handleChange={(state_key, value) => {
                    this.handleChange(value, state_key[0]);
                    //this.getAdaptors(value)
                  }}
                />
              </div>
              <ThemeProvider theme={blue_theme}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "15px",
                    justifyContent: "space-around",
                  }}
                >
                  <Button
                    style={{
                      width: "48%",
                    }}
                    //fullWidth = {true}
                    variant="contained"
                    color="primary"
                    onClick={this.validateAndCreateWorkFlow}
                  >
                    Submit
                  </Button>

                  <Button
                    style={{
                      width: "48%",
                      //marginLeft: "8px"
                    }}
                    color="secondary"
                    variant="outlined"
                    onClick={(event) => {
                      event.preventDefault();
                      this.props.closePopup();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </ThemeProvider>
              <AddWebService
                open={this.state.add_web_service}
                handleClose={this.closeWebServiceDialog}
              />
            </ThemeProvider>
          </Paper>
        </div>

        {this.state.error === true && (
          <ErrorMessageAlert
            open={this.state.error}
            handleClose={this.closeError}
            errorInfo={this.state.error_message}
          />
        )}
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(CreateWorkflow));
